import Vue from 'vue'
import router from './router'
import store from './store'
import VueBootstrap from 'bootstrap-vue'
import VueClipboard from 'vue-clipboard2'
import VueNVD3 from 'vue-nvd3'
import VueInsProgressBar from 'vue-ins-progress-bar'
// import VueEventCalendar from 'vue-event-calendar'
// import VueSparkline from 'vue-sparklines'
import Vueditor from '@agametov/vueditor'
import '@agametov/vueditor/dist/style/vueditor.min.css'
// import VueHljs from 'vue-hljs'
// import VueSweetalert2 from 'vue-sweetalert2'
// import VueNotification from 'vue-notification'
import VuePanel from './plugins/panel/'
// import VueDateTimePicker from 'vue-bootstrap-datetimepicker'
// import VueSelect from 'vue-select'
// import VueDatepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
// import VueMaskedInput from 'vue-maskedinput'
// import VueInputTag from 'vue-input-tag'
// import VueSlider from 'vue-slider-component'
// import VueGoodTable from 'vue-good-table'
// import VueFullCalendar from 'vue-full-calendar'
// import VueCountdown from '@xkeshi/vue-countdown'
// import VueColorpicker from 'vue-pop-colorpicker'
import VueSlimScroll from 'vue-slimscroll'
import moment from 'moment'
import VTooltip from 'v-tooltip'
import VueCustomScrollbar from 'vue-custom-scrollbar'
import * as VueGoogleMaps from 'vue2-google-maps'

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

// iview
import 'view-design/dist/styles/iview.css'
import 'vue-custom-scrollbar/dist/vueScrollbar.css'

// use a new library ant-vue-desing
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

import './style/main.scss'

import './components/common'
import App from './App.vue'
import { Toast, ModalDialog } from './plugins'
import i18n from './i18n'

import VueCroppie from 'vue-croppie'
import 'croppie/croppie.css'
import VueLazyload from 'vue-lazyload'
import Vuelidate from 'vuelidate'

import { round } from 'lodash'

// your config here
let config = {
  toolbar: [
    'removeFormat',
    'undo',
    '|',
    'elements',
    'fontName',
    'fontSize',
    'foreColor',
    'backColor',
    'divider',
    'bold',
    'italic',
    'underline',
    'strikeThrough',
    'links',
    'divider',
    'subscript',
    'superscript',
    'divider',
    'justifyLeft',
    'justifyCenter',
    'justifyRight',
    'justifyFull',
    '|',
    'indent',
    'outdent',
    'insertOrderedList',
    'insertUnorderedList',
    'tables',
    '|',
    'switchView'
  ],
  fontName: [
    { val: 'arial black' },
    { val: 'khmer os' },
    { val: 'times new roman' },
    { val: 'Courier New' }
  ],
  fontSize: [
    '12px',
    '14px',
    '16px',
    '18px',
    '0.8rem',
    '1.0rem',
    '1.2rem',
    '1.5rem',
    '2.0rem'
  ]
}

Vue.config.productionTip = false

Vue.use(Antd)
Vue.use(VueClipboard)
Vue.use(VueBootstrap)
Vue.use(VueCroppie)
Vue.use(VueLazyload)
Vue.use(Vuelidate)
Vue.use(VueNVD3)
// Vue.use(VueEventCalendar, { locale: 'en' })
// Vue.use(VueSparkline)
Vue.use(Vueditor, config)
// Vue.use(VueHljs)
// Vue.use(VueSweetalert2)
// Vue.use(VueNotification)
Vue.use(VuePanel)
Vue.use(VuePanel)
// Vue.use(VueDateTimePicker)
// Vue.use(VueGoodTable)
// Vue.use(VueFullCalendar)
// Vue.use(VueColorpicker)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA6fnbSNLpeJ4FeP1djG20_i4FTDdjXDLc',
    libraries: 'places',
    language: 'km'
  }
})
Vue.use(VueInsProgressBar, {
  position: 'fixed',
  show: true,
  height: '3px'
})
Vue.use(VueSlimScroll)
// Vue.component('v-select', VueSelect)
// Vue.component('datepicker', VueDatepicker)
// Vue.component('masked-input', VueMaskedInput)
// Vue.component('input-tag', VueInputTag)
// Vue.component('vue-slider', VueSlider)
// Vue.component(VueCountdown.name, VueCountdown)
Vue.component('treeselect', Treeselect)
Vue.use(Toast, { position: 'top-right', duration: 2000 })
Vue.use(ModalDialog)
Vue.use(VTooltip)
Vue.component('vue-custom-scrollbar', VueCustomScrollbar)

moment.locale('en', {
  week: {
    dow: 1
  }
})

// defined prototype
Vue.prototype.$formatNumber = function(number = 0, digit = 0) {
  return number.toLocaleString('en-US', { minimumFractionDigits: digit })
}

Vue.prototype.$currencyFormat = function (number, currency = 'USD', country = 'en-US', digit = 2) {
  if (number) {
    var sign = currency.toLocaleLowerCase() == 'usd' ? 'USD' : 'THB';
    var locale = currency.toLocaleLowerCase() == 'usd' ? 'en-US' : 'th-TH';

    // return sign + ' ' +  round(number, digit).toLocaleString('en-US', digit)
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: sign,
      decimal: digit
    }).format(number)
  }
}
Vue.prototype.$defaultCurrencyWithCode = function(value = 0, decimal = 2) {
  let currency_code = store.state.authUser.sys_setting.default_currency
  let currency_sign = store.state.authUser.sys_setting.default_currency_sign

  if (value) {
    let decimalDigit = (value / 1).toFixed(decimal).replace(',', '.')
    let val = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    if (currency_code == 'KHR') {
      return currency_sign + ' ' + val
      // if (decimalDigit.substring(decimalDigit.indexOf('.') + 1) == 0) {
      //   return currency_sign + ' ' + val
      // }
      // return (
      //   currency_sign +
      //   ' ' +
      //   (val.split('.')[0] + decimalDigit.substring(decimalDigit.indexOf('.')))
      // )
    }
    if (value.toString().indexOf('.') >= 0) {
      // input value with decimal
      return (
        currency_sign +
        ' ' +
        val.split('.')[0] +
        decimalDigit.substring(decimalDigit.indexOf('.'))
      )
    }
    return (
      currency_sign +
      ' ' +
      val +
      decimalDigit.substring(decimalDigit.indexOf('.'))
    )
  }
  return currency_sign + ' ' + 0
}
Vue.prototype.$defaultCurrencyWithCodeV2 = function(value = 0) {
  let currency_code = store.state.authUser.sys_setting.default_currency
  let currency_sign = store.state.authUser.sys_setting.default_currency_sign
  let decimal = store.state.authUser.sys_setting.decimal_digit || 2 //  from sys_setting

  if (value) {
    let decimalDigit = (value / 1).toFixed(decimal).replace(',', '.')
    let val = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    if (currency_code == 'KHR') {
      return currency_sign + ' ' + val
    }
    if (value.toString().indexOf('.') >= 0) {
      return (
        currency_sign +
        ' ' +
        val.split('.')[0] +
        decimalDigit.substring(decimalDigit.indexOf('.'))
      )
    }
    return (
      currency_sign +
      ' ' +
      val +
      decimalDigit.substring(decimalDigit.indexOf('.'))
    )
  }
  return currency_sign + ' ' + 0
}
new Vue({
  router,
  store,
  i18n,
  data: {
    appName: process.env.VUE_APP_NAME
  },
  render: h => h(App)
}).$mount('#app')
